export default __webpack_public_path__ + "static/media/Read-Regular_V3000.d4c1b46e.woff";